import Image from "next/image";
import {getColor} from "@/styles/ThemeConfig";
import styled from 'styled-components';

export default function ReviewOverlay({ data, showDesktop = true, showMobile = true }) {

    return (
        <>
            {showDesktop && (
                <DesktopOverlay className={'desktop_only_flex'}>
                    <ReviewSection>
                        <ReviewText>{data?.data?.leftText}</ReviewText>
                        <Image
                            priority
                            loading={'eager'}
                            src={data?.leftImageDesktop?.url}
                            alt={data?.leftImageDesktop?.alt ?? data?.leftImageDesktop?.name}
                            width="430"
                            height="46"
                            style={{
                                width: '430px',
                                maxWidth: '100%',
                                height: 'auto',
                            }}
                        />
                    </ReviewSection>
                    <RecommendationSection>
                        <ReviewText>{data?.data?.rightText}</ReviewText>
                        <Image
                            priority
                            loading={'eager'}
                            src={data?.rightImageDesktop?.url}
                            alt={data?.rightImageDesktop?.alt ?? data?.rightImageDesktop?.name}
                            width="350"
                            height="85"
                            style={{
                                width: '350px',
                                maxWidth: '100%',
                                height: 'auto',
                            }}
                        />
                    </RecommendationSection>
                </DesktopOverlay>
            )}

            {showMobile && (
                <MobileOverlay className={'mobile_only_flex'}>
                    <ReviewSection>
                        <ReviewText>{data?.data?.leftText}</ReviewText>
                        <Image
                            priority
                            loading={'eager'}
                            src={data?.leftImageMobile?.url}
                            alt={data?.leftImageMobile?.alt ?? data?.leftImageMobile?.name}
                            width="350"
                            height="85"
                            style={{
                                width: '350px',
                                maxWidth: '100%',
                                height: 'auto',
                            }}
                        />
                    </ReviewSection>
                    <RecommendationSection>
                        <ReviewText>{data?.data?.rightText}</ReviewText>
                        <Image
                            priority
                            loading={'eager'}
                            src={data?.rightImageMobile?.url}
                            alt={data?.leftImageMobile?.alt ?? data?.leftImageMobile?.name}
                            width="430"
                            height="46"
                            style={{
                                width: '430px',
                                maxWidth: '100%',
                                height: 'auto',
                            }}
                        />
                    </RecommendationSection>
                </MobileOverlay>
            )}
        </>
    );
}

// Styled Components

const DesktopOverlay = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-family: 'Playfair Display',serif;
    font-size: 15px;
    color: white;
    padding: 30px;
    //opacity: 0.8;
`;

const MobileOverlay = styled.div`
    font-family: 'Playfair Display',serif;
    font-size: 15px;
    color: ${getColor('greenText')};
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-top:30px;
`;

const ReviewSection = styled.div`
    display: flex;
    flex-direction: column;
`;

const RecommendationSection = styled.div`
    display: flex;
    flex-direction: column;
`;

const ReviewText = styled.div`
    font-family: 'Playfair Display';
`;
